//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  ActionRounded,
  IconChevronLeft,
  IconChevronRight,
} from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'

import {
  DATA_SELECTOR_ATTRIBUTE_FOR_SEO,
  FIRST_PAGINATION_INDEX,
} from './Pagination.constants'
import translations from './Pagination.translations'
import PaginationButton from './PaginationButton'
import { pagination } from './utils'

export default {
  components: {
    ActionRounded,
    PaginationButton,
  },
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    nbPages: {
      type: Number,
      required: true,
    },
  },
  computed: {
    translations: () => translations,

    dataSelectorAttribute: () => DATA_SELECTOR_ATTRIBUTE_FOR_SEO,

    icons() {
      return {
        left: IconChevronLeft,
        right: IconChevronRight,
      }
    },

    pagination() {
      return pagination(this.currentPage, this.nbPages)
    },
    hasPagination() {
      return !isEmpty(this.pagination)
    },
    firstPage() {
      const [firstPaginationItem] = this.pagination

      return firstPaginationItem === FIRST_PAGINATION_INDEX
        ? null
        : FIRST_PAGINATION_INDEX
    },
    lastPage() {
      const [lastPaginationItem] = this.pagination.slice(-1)

      return lastPaginationItem === this.nbPages ? null : this.nbPages
    },
    hasDotsLastPage() {
      const [lastPaginationItem] = this.pagination.slice(-1)

      return lastPaginationItem + 1 < this.nbPages
    },
    hasDotsFirstPage() {
      const [firstPaginationItem] = this.pagination

      return firstPaginationItem - 1 > FIRST_PAGINATION_INDEX
    },
  },
  methods: {
    onClick(pageNumber) {
      this.$emit('change', 'page', pageNumber)
    },
  },
}
